module.exports = __webpack_public_path__ + "img/background-desktop-party.252366a6.png";